module.exports = __webpack_public_path__ + "img/deti-krug.c7c42f00.png";